import { redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"
import { z } from "zod"

import { parseFormData } from "@/form"

import { getRedirectUrl, requestOtp, verifyOtp } from "../auth.server"
import { setSessionCookie } from "../session.server"

export const requestOtpFormSchema = z.object({
  email: z.string().email("Enter a valid email address"),
})

export const verifyOtpFormSchema = z.object({
  email: z.string().email(),
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/, "Enter the 6-digit code"),
  redirectTo: z.string().optional(),
})

const OTP_ERRORS = {
  INVALID_CODE: "That code isn't right. Check it and try again.",
  EXPIRED: "That code has expired. Request a new one.",
  TOO_MANY_ATTEMPTS: "Too many attempts. Request a new code.",
} as const

export const requestOtpAction = createServerFn({ method: "POST" })
  .validator((data: FormData) => parseFormData(requestOtpFormSchema, data))
  .handler(async ({ data }) => {
    const result = await requestOtp(data.email)
    if (!result.ok) {
      return { error: "No account exists for that email address." }
    }
    return { sent: true, email: data.email.trim().toLowerCase(), devCode: result.devCode }
  })

export const verifyOtpAction = createServerFn({ method: "POST" })
  .validator((data: FormData) => parseFormData(verifyOtpFormSchema, data))
  .handler(async ({ data }) => {
    const result = await verifyOtp(data.email, data.code)
    if (!result.ok) {
      return { error: OTP_ERRORS[result.code] }
    }
    await setSessionCookie(result.userId)
    throw redirect({ to: getRedirectUrl(data.redirectTo) })
  })
